import React from "react";
import CompleteTodoFooter from "./CompleteTodoFooter";
import CompleteTodoHeader from "./CompleteTodoHeader";
import CompleteTodoList from "./CompleteTodoList";

const CompleteTodo = () => {
  return (
    <div className="w-full max-w-3xl shadow-lg rounded-lg p-6 bg-white mt-10">
      <CompleteTodoHeader />
      <hr className="mt-1" />
      <CompleteTodoList />
      <hr className="mt-4" />
      <CompleteTodoFooter />
    </div>
  );
};

export default CompleteTodo;
